import { render, staticRenderFns } from "./BookkeepingPage.vue?vue&type=template&id=25eb1968"
import script from "./BookkeepingPage.vue?vue&type=script&lang=js"
export * from "./BookkeepingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports